import dialogMixin from "./dialog";
export default {
  mixins: [dialogMixin],
  data() {
    return {
     
    };
  },
  computed: {
    hasAttach() {
      return this.$refs["attach"] ? true : false;
    }
  }
}